import { Link } from "react-router-dom";
import Logo from "./Logo";
import { contact } from "@/data/contact";

const FOOTER_NAV = [
  { to: "/", label: "Home" },
  { to: "/company", label: "Our Company" },
  { to: "/divisions", label: "Our Divisions" },
  { to: "/divisions/petroleum-energy", label: "Petroleum & Energy" },
  { to: "/divisions/precious-metals", label: "Precious Metals" },
  { to: "/strategic-relationships", label: "Strategic Relationships" },
  { to: "/leadership", label: "Leadership" },
  { to: "/careers", label: "Careers" },
  { to: "/privacy", label: "Privacy Notice" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer className="gp-footer" data-testid="site-footer">
      <div className="gp-wrap">
        <div className="gp-footer__cols">
          <div className="gp-footer__brand">
            <Logo />
            <p>
              UAE-registered trading company. Petroleum, gas, derivatives and
              non-manufactured precious metals.
            </p>
          </div>

          <div>
            <div className="gp-footer__title">Navigate</div>
            <ul className="gp-footer__nav" data-testid="footer-nav">
              {FOOTER_NAV.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} data-testid={`footer-link-${slug(item.label)}`}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="gp-footer__title">Contact</div>
            <div className="gp-footer__contact">
              <div>
                <strong>Company telephone</strong>
                <a href={`tel:${contact.company_phone.tel}`} data-testid="footer-company-tel">
                  {contact.company_phone.raw}
                </a>
              </div>
              <div>
                <strong>Sales enquiries</strong>
                <a href={`mailto:${contact.sales_email.address}`} data-testid="footer-email-sales">
                  {contact.sales_email.address}
                </a>
              </div>
              <div>
                <strong>General enquiries</strong>
                <a href={`mailto:${contact.general_email.address}`} data-testid="footer-email-general">
                  {contact.general_email.address}
                </a>
              </div>
              <div>
                <strong>{contact.leadership.name}</strong>
                <div>{contact.leadership.title}</div>
              </div>
              <div>
                <strong>{contact.sales_contact.name} — {contact.sales_contact.role}</strong>
                <div>
                  {contact.sales_contact.region}&nbsp;
                  <a href={`tel:${contact.sales_contact.tel}`} data-testid="footer-fabio-ca">
                    {contact.sales_contact.raw}
                  </a>
                </div>
              </div>
              <div>
                <strong>Location</strong>
                United Arab Emirates
              </div>
            </div>
          </div>
        </div>

        <div className="gp-footer__bottom">
          <div data-testid="footer-copyright">© 2026 Gold Petroleum FZ LLC.</div>
          <div style={{ maxWidth: "60ch" }} data-testid="footer-imagery-disclaimer">
            Imagery is illustrative of the industry and does not depict assets owned by
            Gold Petroleum FZ LLC.
          </div>
        </div>
      </div>
    </footer>
  );
}

function slug(s) {
  return s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}
